var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyRedeem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00002 18C4.04494 18 0 13.9551 0 9.00002C0 4.04497 4.04494 0 9.00002 0C11.3933 0 13.6854 0.943814 15.3708 2.6292C17.0562 4.31458 18 6.60673 18 8.99998C18 13.9551 13.9551 18 9.00002 18ZM9.00002 1.82022C12.9775 1.82022 16.1798 5.05619 16.1798 9.00002C16.1798 10.9214 15.4382 12.7416 14.0899 14.0899C12.7416 15.4382 10.9214 16.1798 9.00002 16.1798C5.02248 16.1798 1.82022 12.9438 1.82022 9.00002C1.82022 5.05619 5.02248 1.82022 9.00002 1.82022Z",
    fill: "#9C9D9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRedeem);
export default __webpack_public_path__ + "static/media/emptyRedeem.ec2f57e613551947e2a175890cc5b511.svg";
export { ForwardRef as ReactComponent };